import { render, staticRenderFns } from "./InkindMatchForm.vue?vue&type=template&id=0e42b599&"
import script from "./InkindMatchForm.vue?vue&type=script&lang=js&"
export * from "./InkindMatchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports